import { useEffect } from "react";
import { BRAND_ASSETS } from "@/lib/brandAssets";

const SITE_URL = "https://junkindatruck.com";
const DEFAULT_TITLE = "Junk Removal in Vero Beach, FL | Junk In Da Truck";
const DEFAULT_DESCRIPTION = "Junk In Da Truck provides fast junk removal in Vero Beach, FL, with furniture hauling, cleanouts, upfront pricing, and same-day service.";
const DEFAULT_IMAGE = BRAND_ASSETS.social;

function ensureTag(selector, tagName, attrs = {}) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(tagName);
    Object.entries(attrs).forEach(([key, value]) => el.setAttribute(key, value));
    document.head.appendChild(el);
  }
  return el;
}

export default function SEO({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  robots = "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
  schema,
}) {
  useEffect(() => {
    const canonicalUrl = new URL(path, SITE_URL).toString();
    document.title = title;

    ensureTag('meta[name="description"]', 'meta', { name: 'description' }).setAttribute('content', description);
    ensureTag('meta[name="googlebot"]', 'meta', { name: 'googlebot' }).setAttribute('content', robots);
    ensureTag('meta[name="robots"]', 'meta', { name: 'robots' }).setAttribute('content', robots);
    ensureTag('link[rel="canonical"]', 'link', { rel: 'canonical' }).setAttribute('href', canonicalUrl);

    ensureTag('meta[property="og:type"]', 'meta', { property: 'og:type' }).setAttribute('content', type);
    ensureTag('meta[property="og:url"]', 'meta', { property: 'og:url' }).setAttribute('content', canonicalUrl);
    ensureTag('meta[property="og:title"]', 'meta', { property: 'og:title' }).setAttribute('content', title);
    ensureTag('meta[property="og:description"]', 'meta', { property: 'og:description' }).setAttribute('content', description);
    ensureTag('meta[property="og:image"]', 'meta', { property: 'og:image' }).setAttribute('content', image);
    ensureTag('meta[property="og:site_name"]', 'meta', { property: 'og:site_name' }).setAttribute('content', 'Junk In Da Truck');

    ensureTag('meta[name="twitter:card"]', 'meta', { name: 'twitter:card' }).setAttribute('content', 'summary_large_image');
    ensureTag('meta[name="twitter:title"]', 'meta', { name: 'twitter:title' }).setAttribute('content', title);
    ensureTag('meta[name="twitter:description"]', 'meta', { name: 'twitter:description' }).setAttribute('content', description);
    ensureTag('meta[name="twitter:image"]', 'meta', { name: 'twitter:image' }).setAttribute('content', image);

    let schemaTag = document.head.querySelector('script[data-dynamic-seo="true"]');
    if (schemaTag) schemaTag.remove();

    if (schema) {
      schemaTag = document.createElement('script');
      schemaTag.type = 'application/ld+json';
      schemaTag.setAttribute('data-dynamic-seo', 'true');
      schemaTag.text = JSON.stringify(Array.isArray(schema) ? schema : schema);
      document.head.appendChild(schemaTag);
    }
  }, [title, description, path, image, type, robots, schema]);

  return null;
}
